// extracted by mini-css-extract-plugin
export default {"site-wrapper":"Homepage_site-wrapper__7fC+Y"};